<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addTeachingPointDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
    append-to-body
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item required prop="pointName" label="分点名称:">
          <el-input type="text" v-model="form.pointName"></el-input>
        </el-form-item>
        <el-form-item required prop="pointAddress" label="分点地址:">
          <el-input type="textarea" v-model="form.pointAddress"></el-input>
        </el-form-item>

        <el-form-item prop="pointAddress" label="地图定位">
          <el-amap-search-box
            class="search-box"
            :search-option="searchOption"
            :on-search-result="onSearchResult"
          ></el-amap-search-box>
        </el-form-item>

        <el-form-item required prop="isShow" label="是否显示在小程序:">
          <el-select v-model="form.isShow" placeholder="是否显示在小程序">
            <el-option
              v-for="item in isShowType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item required prop="schoolInfoId" label="所属校区:">
          <el-select v-model="form.schoolInfoId" placeholder="选择校区">
            <el-option
              v-for="item in this.schoolInfoList.schoolInfoList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="地点图片">
          <el-upload
            action="/api/manager/file/uploadPhotos"
            :data="pictureType1"
            :file-list="detailImgList"
            :limit="1"
            :on-exceed="handleExceed"
            name="picture"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleDetailsRemove"
            :on-success="handleDetailsSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" size="tiny" append-to-body>
            <img width="100%" :src="dialogDetailsImageUrl" alt />
          </el-dialog>
        </el-form-item>

        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { addTeachingpoint, editTeachingpoint } from "@/api/teachingpoint";
import { deleteImage } from "@/api/coach";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  name: "addFundDialogs",
  data() {
    return {
      isVisible: this.isShow,
      form: {
        id: "",
        pointName: "",
        pointAddress: "",
        isShow: "",
        image: "",
        longitude: "",
        latitude: "",
        telephone: "",
        schoolInfoId: "",
      },
      searchOption: {
        city: "全国",
        citylimit: true,
      },
      dialogVisible: false,
      detailImgList: [],
      dialogDetailsImageUrl: "",
      pictureType1: {
        pictureType: "details",
      },
      isShowType: [
        { label: "否", value: 0 },
        { label: "是", value: 1 },
      ],
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    schoolInfoList: Object,
  },
  computed: {
    ...mapGetters(["addTeachingPointDialog"]),
  },
  created() {},
  mounted() {
    if (this.addTeachingPointDialog.type === "edit") {
      this.form = this.dialogRow.param;
      if (this.form.image !== "" && this.form.image !== null) {
        let detailsImgList = [
          {
            name: "",
            url: this.form.image,
          },
        ];
        this.detailImgList = detailsImgList;
        this.dialogDetailsImageUrl = this.form.image;
      }
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //图片预览的处理函数
    handlePictureCardPreview(file) {
      this.dialogVisible = true;
    },
    onSearchResult(pois) {
      // console.log(pois, "pois");
      var lng = pois[0].lng;
      var lat = pois[0].lat;
      // this.form.pointName = pois[0].name;
      // this.form.pointAddress = pois[0].address;
      this.form.longitude = lng;
      this.form.latitude = lat;
      this.form.telephone = pois[0].tel;
      console.log(this.form);
    },
    //上传之前的格式验证函数
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      // const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 4;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 4MB!");
      }
      // return (isJPG || isJPG) && isLt2M;
      return isLt2M;
    },
    //教练详情图片上传成功的回调函数
    handleDetailsSuccess(res, file) {
      this.$message({
        type: "info",
        message: "图片上传成功",
        duration: 6000,
      });
      console.log(file.response);
      if (file.response.code == 200) {
        //更新图片列表
        let fileList = [
          {
            name: "",
            url: file.response.data.url,
          },
        ];
        this.detailImgList = fileList;
        //更新预览图片的路径
        this.dialogDetailsImageUrl = file.response.data.url;
        this.form.image = file.response.data.url;
      }
    },
    //上传图片大于上限的处理函数
    handleExceed() {
      this.$message({
        type: "info",
        message: "只能上传一张图片",
        duration: 6000,
      });
    },
    //删除图片的处理函数
    handleDetailsRemove(file, fileList) {
      let para = {
        url: this.form.image,
      };
      console.log(para);
      deleteImage(para).then((res) => {
        console.log(res);
        this.form.image = "";
        this.detailImgList = [];
      });
      this.$message({
        type: "info",
        message: "已删除原有图片",
        duration: 6000,
      });
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData);
          console.log(para);
          // edit
          if (this.addTeachingPointDialog.type === "edit") {
            editTeachingpoint(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "修改(" + this.form.pointName + ")教学分点操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.isVisible = false;
                this.$emit("getAppointmenttypeList");
              }
            });
          } else {
            // add
            addTeachingpoint(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "新增(" + this.form.pointName + ")教学分点操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getAppointmenttypeList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
